import { useRef } from "react";
import type { UseKarlBeatClass } from "./types";

export const useKarlBeatClass: UseKarlBeatClass = (index) => {
  const previous = useRef(index);
  // Read during render, not in an effect: the beat remounts on the same render
  // that the index moves, so the class has to be right first time or it misses.
  const direction = index < previous.current ? "karl-beat-prev" : "karl-beat-next";
  previous.current = index;
  return direction;
};
